var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input input--text", class: _vm.inputClass },
    [
      _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      !_vm.textarea
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue"
              }
            ],
            attrs: {
              type: "text",
              placeholder: _vm.placeholder,
              disabled: _vm.disabled
            },
            domProps: { value: _vm.currentValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentValue = $event.target.value
              }
            }
          })
        : _vm._e(),
      _vm.textarea
        ? _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue"
              }
            ],
            attrs: { placeholder: _vm.placeholder, disabled: _vm.disabled },
            domProps: { value: _vm.currentValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentValue = $event.target.value
              }
            }
          })
        : _vm._e(),
      _vm.error ? _c("span", [_vm._v(_vm._s(_vm.error))]) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }